import { render, staticRenderFns } from "./opportunity-card.vue?vue&type=template&id=5d56761b&scoped=true&"
import script from "./opportunity-card.vue?vue&type=script&lang=js&"
export * from "./opportunity-card.vue?vue&type=script&lang=js&"
import style0 from "./opportunity-card.vue?vue&type=style&index=0&id=5d56761b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d56761b",
  null
  
)

export default component.exports